export default {
	SET_LANGUAGE_PAIR_GROUPS: "SET_LANGUAGE_PAIR_GROUPS",
	SET_LOADING: "SET_LOADING"
}